export default __webpack_public_path__ + "static/media/playbuttonorange.76b7d4ec.svg";